import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';

import {
  QuestionLabel,
  Container,
  Image,
  Modal,
  ModalContent,
  ImageContainer,
  ModalImage,
  Link,
  ContainerImage,
  ImageLabel,
} from './styles';

const ImageQuestionType = (props) => {
  const [loading, setLoading] = useState(true);

  const { label, imageUrl } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
  }, [imageUrl]);

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setLoading(false);
  };

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>
      <ContainerImage>
        {imageUrl && (
          <>
            {loading && <Loader size="small" data-loader="image-question-loader" />}
            <Image
              as="img"
              src={imageUrl}
              onLoad={handleImageLoad}
              onError={handleImageError}
              isLoading={loading}
            />
            <ImageLabel>
              <Link onClick={() => setIsModalOpen(true)}>
                Click to enlarge image
              </Link>
            </ImageLabel>
          </>
        )}
        {isModalOpen && (
          <Modal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            closeIcon
          >
            <ModalContent>
              <ImageContainer>
                <ModalImage
                  src={imageUrl}
                />
              </ImageContainer>
              <Link onClick={() => setIsModalOpen(false)}>
                Exit Image Preview
              </Link>
            </ModalContent>
          </Modal>
        )}
      </ContainerImage>
    </Container>
  );
};

ImageQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
};

ImageQuestionType.defaultProps = {
  imageUrl: null,
};

export default ImageQuestionType;
